export default __webpack_public_path__ + "static/media/img_post7.0b0a050d.png";